import { Popover, useDisclosure } from '@chakra-ui/react';
import { IUsageTypeResSchema } from '@monetize/types/app';
import { Fragment } from 'react';
import FocusLock from 'react-focus-lock';
import {
  MGrid,
  MGridItem,
  MIDCopyBox,
  MLink,
  MText,
} from '../../../../../components/Monetize';
import { FOCUS_WITHOUT_SCROLLING } from '../../../../../components/Monetize/Overlays';

interface UsageTypeWithDetailsProps {
  usageTypes: IUsageTypeResSchema[];
}

export const UsageTypeWithDetails = ({
  usageTypes,
}: UsageTypeWithDetailsProps) => {
  const { onOpen, onClose, open: isOpen } = useDisclosure();

  if (!usageTypes || usageTypes.length === 0) {
    return null;
  }

  return (
    <Popover.Root
      lazyMount
      unmountOnExit
      open={isOpen}
      onOpenChange={(e) => {
        if (e.open) {
          onOpen();
        } else {
          onClose();
        }
      }}
      positioning={{
        placement: 'right',
      }}
    >
      <Popover.Trigger asChild>
        <MLink onClick={onOpen} fontSize="sm" cursor="pointer">
          {usageTypes.length > 1 ? 'Multiple' : usageTypes[0].name}
        </MLink>
      </Popover.Trigger>
      <Popover.Positioner>
        <Popover.Content p={4} border="0" boxShadow="popover">
          <FocusLock
            focusOptions={FOCUS_WITHOUT_SCROLLING}
            persistentFocus={false}
          >
            <Popover.Arrow mt="1" />
            {usageTypes.length === 1 ? (
              <MGrid templateColumns={'1fr'} columnGap={8}>
                <MGridItem py={2}>
                  <MText fontWeight="bold">Usage Type ID</MText>
                </MGridItem>
                <MGridItem py={1}>
                  <MIDCopyBox
                    copyValue={usageTypes[0].id}
                    tooltipMessage="Copy Usage Type ID to Clipboard"
                  />
                </MGridItem>
              </MGrid>
            ) : (
              <MGrid templateColumns={'1fr 1fr'} columnGap={8}>
                <MGridItem py={2}>
                  <MText fontWeight="bold">Usage Type ID</MText>
                </MGridItem>
                <MGridItem py={2}>
                  <MText fontWeight="bold">Usage Type</MText>
                </MGridItem>
                {usageTypes.map((usageType, index) => (
                  <Fragment key={index}>
                    <MGridItem py={1}>
                      <MIDCopyBox
                        copyValue={usageType.id}
                        tooltipMessage="Copy Usage Type ID to Clipboard"
                      />
                    </MGridItem>
                    <MGridItem py={1}>
                      <MText>{usageType.name}</MText>
                    </MGridItem>
                  </Fragment>
                ))}
              </MGrid>
            )}
          </FocusLock>
        </Popover.Content>
      </Popover.Positioner>
    </Popover.Root>
  );
};
